/**
 * @ngdoc Directive
 * @name vrmEvGpsWidget
 * @example
 *
 * <vrmEvGpsWidget installation="installation" />
 *
 */
import { handleFileDownload } from "@/utils/download";

(function() {
    'use strict';

    angular.module('vrm.components')
        .directive('vrmEvGpsWidget', vrmEvGpsWidget);

    /* @ngInject */
    function vrmEvGpsWidget() {

        return {
            restrict: 'E',
            template: require('@/angular/modules/vrm-components/ev-gps-widget/ev-gps-widget.template.html'),
            controller: controller,
            scope: {
                iconClass: '=',
                customName: '=',
                installation: '=',
                instance: '=',
                range: '=',
                widgetId: '=',
                isMobile: '=',
                hasTouchEnabled: '=',
                size: '=',
                itemState: '=?'
            }
        };

        /* @ngInject */
        function controller($scope, ApiService, moment, locale) {
            let chartHeightMobile = '400px';
            /**
             * Get a field from the retrieved data
             * @param fieldName
             * @returns {*}
             */
            $scope.getField = function(fieldName) {
                if ($scope.data && $scope.data.records) {
                    const data = _.find($scope.data.records.data.attributes, {code: fieldName});
                    if (data && fieldName === 'evas') {
                        const translationKey = data.valueFormattedWithUnit === 'At site' ? 'Yes' : 'No';
                        return locale.getString(translationKey);
                    }
                    return data;
                } else {
                    return null;
                }
            };

            $scope.download = function() {
                ApiService.installationDownload($scope.installation.id, 'ev-gps-download', {
                    instance: $scope.instance,
                    start: $scope.range.startDate,
                    end: $scope.range.endDate
                }).then(function(response) {
                    handleFileDownload(response.data, $scope.widgetTitle() + '.kml');
                });
            };

            $scope.$watch('size', () => {
                if (!$scope.chart || !$scope.chart.getHighcharts) return;
                $scope.chart.getHighcharts().reflow();
            });

            $scope.isFullscreen = false;

            $scope.clickExpand = () => {
                if ($scope.itemState) {
                    $scope.itemState.expanded = !$scope.itemState.expanded;
                    $scope.isFullscreen = $scope.itemState.expanded;
                }
            }

            $scope.gpsPath = null;

            $scope.$watch('installation', function(installation) {
                if (installation != null) {
                    $scope.now = Math.floor(Date.now() / 1000);

                    $scope.map = {
                        control: {},
                        center: {
                            latitude: installation.data.evpt ? installation.data.evpt.rawValue : null,
                            longitude: installation.data.evpg ? installation.data.evpg.rawValue : null
                        },
                        coords: {
                            latitude: installation.data.evpt ? installation.data.evpt.rawValue : null,
                            longitude: installation.data.evpg ? installation.data.evpg.rawValue : null
                        },
                        zoom: 7,
                        options: {
                            // Style
                            styles: [{
                                stylers: [{
                                    visibility: "simplified"
                                }]
                            }],

                            // Control buttons
                            mapTypeControl: true,
                            panControl: false,
                            zoomControl: true,
                            scaleControl: false,
                            rotateControl: false,
                            streetViewControl: false,
                            overviewMapControl: false,

                            scrollwheel: true
                        },
                    };
                }
                refreshData();
            }, true);

            // Also watch on range, since otherwise it does not refetch data
            $scope.$watchGroup(['range.startDate', 'range.endDate'], function(newVals, oldVals) {
                if (newVals === oldVals) {
                    return;
                }
                refreshData();
            }, true);

            function refreshData() {
                // Get data from lastlogdata to show current location & info.
                const requestPath = 'widgets/EvGPS?instance=' + $scope.instance;
                ApiService.installations($scope.installation.id, requestPath).then(function(response) {
                    $scope.data = response.data;
                    if ($scope.map.coords.latitude == $scope.map.center.latitude && $scope.map.coords.longitude == $scope.map.center.longitude) {
                        $scope.map.center.latitude = $scope.getField('evpt') ? $scope.getField('evpt').value : null;
                        $scope.map.center.longitude = $scope.getField('evpg') ? $scope.getField('evpg').value : null;
                    }
                    $scope.map.coords.latitude =  $scope.getField('evpt') ? $scope.getField('evpt').value : null;
                    $scope.map.coords.longitude = $scope.getField('evpg') ? $scope.getField('evpg').value : null;
                });

                // Get data from influx, to show past GPS data as GeoJSON on the map.
                // Use call2 so we can silently ignore the access-denied for site-share users.
                const path = '/installations/' + $scope.installation.id + '/ev-gps-download'
                const data = {
                    instance: $scope.instance,
                    start: $scope.range.startDate,
                    end: $scope.range.endDate,
                    getAsGeoJson: true
                }
                ApiService.call2(
                    path, data, { skipResultChecks: true }
                ).then(function(response) {
                    $scope.gpsPath = response.data.records.geoJson;
                });
            }

            $scope.widgetTitle = function () {
                let title = locale.getString('advanced.ev_gps');
                if ($scope.customName) {
                    title = `${$scope.customName} - ` + title;
                }
                if (parseInt($scope.instance)) {
                    title += ` [${$scope.instance}]`;
                }
                return title;
            };
        }
    }
})();
